import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Store } from '../models/store';
import { PaymentMethod } from '../models/payment-method.model';

@Injectable({
  providedIn: 'root'
})
export class StoresService {

  private selectedStoreSource = new BehaviorSubject(null);
  selectedStore$ = this.selectedStoreSource.asObservable();
  private specialTaxpayerStoreSource = new BehaviorSubject(null);
  specialTaxpayerStoreSource$ = this.specialTaxpayerStoreSource.asObservable();
  private dolarSource = new BehaviorSubject(0);
  dolarSource$ = this.dolarSource.asObservable();
  private eurSource = new BehaviorSubject(0);
  eurSource$ = this.eurSource.asObservable();
  private igtfSource = new BehaviorSubject(0);
  igtfSource$ = this.igtfSource.asObservable();


  constructor(private http: HttpClient) { }

  get getSelectedStore() {
    return this.selectedStoreSource.value;
  }

  setSelectedStore(store: Store) {
    this.selectedStoreSource.next(store);
  }

  get getSpecialTaxpayerStore(){
    return this.specialTaxpayerStoreSource.value;
  }

  setSpecialTaxpayerStore(specialTaxpayerStore){
    this.specialTaxpayerStoreSource.next(specialTaxpayerStore);
  }

  get getIgtf(){
    return this.igtfSource.value;
  }

  setIgtf(igtf){
    this.igtfSource.next(igtf);
  }

  get getDolar(){
    return this.dolarSource.value;
  }

  setDolar(dolar){
    this.dolarSource.next(dolar);
  }

  get getEurf(){
    return this.eurSource.value;
  }

  setEur(eur){
    this.eurSource.next(eur);
  }

  getStores(ownerId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/stores/owners/${ownerId}`, httpOptions);
  }

  createStore(store: Store) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post(`${environment.url_api}/stores`, store, httpOptions);
  }

  updateStore(id: number, changes: Partial<Store>) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.patch(`${environment.url_api}/stores/${id}`, changes, httpOptions);
  }

  getPaymentMethodsByStore(storeId: number,type:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<PaymentMethod[]>(`${environment.url_api}/stores/${storeId}/payment-methods?type=${type}`, httpOptions);
  }

  createPaymentMethod(paymentMethod: PaymentMethod) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post(`${environment.url_api}/stores/payment-methods`, paymentMethod, httpOptions);
  }

  updatePaymentMethod(id: number, changes: Partial<PaymentMethod>) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.patch(`${environment.url_api}/stores/payment-methods/${id}`, changes, httpOptions);
  }

  deletePaymentMethod(id: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.delete(`${environment.url_api}/stores/payment-methods/${id}`, httpOptions);
  }

  getShedule(storeId,day){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/stores/${storeId}/schedules?day=${day}`, httpOptions);
  }
}
